import {createSlice} from '@reduxjs/toolkit'

export const askGivePrismSlice = createSlice({
  name: 'askGivePrism',
  initialState: {
    filters: {},
    searchTerm: '',
    searchTermQuery: {previousTerm: '', currentTerm: ''},
    uniqueConstantIdentifier: [],
    switchFilters: false,
    buttonViewName: 'Switch to manual view',
    currentSelectedFilter: {}
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload
    },
    setSearchQuery: (state, action) => {
      state.searchTerm = action.payload
    },
    setSearchTermQuery: (state, action) => {
      state.searchTermQuery.previousTerm = action.payload.previousTerm
      state.searchTermQuery.currentTerm = action.payload.currentTerm
    },
    setUniqueConstituentIdentifier: (state, action) => {
      state.uniqueConstantIdentifier = action.payload
    },
    setSwitchFilters: (state, action) => {
      state.switchFilters = action.payload
    },
    setButtonViewName: (state, action) => {
      state.buttonViewName = action.payload
    },
    setCurrentSelectedFilter: (state, action) => {
      state.currentSelectedFilter = action.payload
    }
  }
})

export const {
  setFilters,
  setSearchQuery,
  setSearchTermQuery,
  setUniqueConstituentIdentifier,
  setSwitchFilters,
  setButtonViewName,
  setCurrentSelectedFilter
} = askGivePrismSlice.actions

export default askGivePrismSlice.reducer
